var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useRef, useState } from 'react';
import { Menu, MenuItem, IconButton } from '@one-thd/sui-atomic-components';
import { More } from '@one-thd/sui-icons';
export var MeatballsMenu = function (_a) {
    var label = _a.label, items = _a.items, size = _a.size, disabled = _a.disabled, MenuProps = _a.MenuProps;
    var menuBtnRef = useRef(null);
    var _b = __read(useState(false), 2), isMenuOpen = _b[0], setIsMenuOpen = _b[1];
    return (React.createElement(React.Fragment, null,
        React.createElement(IconButton, { icon: More, ref: menuBtnRef, onClick: function () {
                setIsMenuOpen(!isMenuOpen);
            }, iconSize: size, role: "combobox", "aria-label": "Edit ".concat(label), "aria-expanded": isMenuOpen, "aria-controls": "edit".concat(label, "Menu"), "aria-haspopup": "listbox", "data-testid": "meatballButton", disabled: disabled }),
        React.createElement("div", { className: "sui-font-regular sui-text-base sui-leading-tight sui-px-3 sui-whitespace-nowrap" },
            React.createElement(Menu, __assign({ id: "edit".concat(label, "Menu"), placement: "bottom-end", open: isMenuOpen, onClose: function () { return setIsMenuOpen(false); }, anchorEl: menuBtnRef.current }, MenuProps, { "data-testid": "meatball-menu" }), items.map(function (_a) {
                var value = _a.value, isHidden = _a.isHidden, isDisabled = _a.isDisabled, action = _a.action;
                return (!isHidden && (React.createElement(MenuItem, { key: value, value: value, disabled: isDisabled, "data-testid": 'option-' + value.toLocaleLowerCase().replace(' ', '-'), onClick: function () {
                        setIsMenuOpen(false);
                        action();
                    } }, value)));
            })))));
};
MeatballsMenu.displayName = 'MeatballsMenu';
